import { FC } from "react";
import { IconPropsType } from ".";

export const EditHistory: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 12V13.5C2 13.7761 2.22386 14 2.5 14H3.79289C3.9255 14 4.05268 13.9473 4.14645 13.8536L13.6464 4.35355C13.8417 4.15829 13.8417 3.84171 13.6464 3.64645L12.3536 2.35355C12.1583 2.15829 11.8417 2.15829 11.6464 2.35355L9.5 4.5"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.5 14H14"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="4" cy="6" r="3.25" stroke={props.color} strokeWidth="1.5" />
      <path
        d="M3 7L4 6V4.5"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
